var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "underage-wrap",
      class: {
        page: _vm.page === "email" || _vm.page === "verify",
        m: !_vm.$utils.isPC,
        [_vm.$i18n.locale]: true,
      },
    },
    [
      _vm.page === "tip"
        ? [
            _c("div", { staticClass: "head" }, [
              _c("div", { staticClass: "back", on: { click: _vm.back } }),
              _vm._v(" " + _vm._s(_vm.$t("underage_tip_7")) + " "),
            ]),
            _c("div", { staticClass: "tips" }, [_vm._v(_vm._s(_vm.msg_tip))]),
            _c("div", { staticClass: "btn-wrap" }, [
              _c(
                "button",
                {
                  staticClass: "btn-no",
                  class: { disabled: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.goSendEmail()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("underage_no")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn-yes",
                  class: { disabled: _vm.loading || _vm.cdSend > 0 },
                  on: {
                    click: function ($event) {
                      return _vm.goSendCode({ is_adult: 1 })
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("underage_yes")) +
                      " " +
                      _vm._s(_vm.cdSend > 0 ? `(${_vm.cdSend}S)` : "") +
                      " "
                  ),
                  _vm.loading
                    ? _c("span", { staticClass: "loading" })
                    : _vm._e(),
                ]
              ),
            ]),
          ]
        : _vm.page === "email"
        ? [
            _c("div", { staticClass: "head" }, [
              _c("div", { staticClass: "back", on: { click: _vm.emailBack } }),
              _vm._v(" " + _vm._s(_vm.$t("underage_tip_8")) + " "),
            ]),
            _c("div", { staticClass: "tips" }, [_vm._v(_vm._s(_vm.msg_tip))]),
            _c("Input", {
              staticClass: "email",
              attrs: { size: "large", placeholder: _vm.$t("underage_tip_10") },
              model: {
                value: _vm.account,
                callback: function ($$v) {
                  _vm.account = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "account",
              },
            }),
            _c(
              "button",
              {
                staticClass: "send",
                class: { disabled: _vm.loading || _vm.cd > 0 || !this.account },
                on: {
                  click: function ($event) {
                    return _vm.sendEmail()
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("test_confirm")) +
                    " " +
                    _vm._s(_vm.cd > 0 ? `(${_vm.cd}S)` : "") +
                    " "
                ),
                _vm.loading ? _c("span", { staticClass: "loading" }) : _vm._e(),
              ]
            ),
          ]
        : _vm.page === "verify"
        ? [
            _c("div", { staticClass: "head" }, [
              _c("div", { staticClass: "back", on: { click: _vm.verifyBack } }),
              _vm._v(" " + _vm._s(_vm.$t("underage_tip_8")) + " "),
            ]),
            _c("div", {
              staticClass: "tips",
              domProps: {
                innerHTML: _vm._s(
                  _vm
                    .$t("underage_tip_1")
                    .replace(`\{\{john123@gmail.com\}\}`, _vm.account)
                ),
              },
            }),
            _c(
              "button",
              {
                staticClass: "send",
                class: { disabled: _vm.loading },
                on: {
                  click: function ($event) {
                    return _vm.isVerified()
                  },
                },
              },
              [
                _vm._v(" " + _vm._s(_vm.$t("underage_tip_9")) + " "),
                _vm.loading ? _c("span", { staticClass: "loading" }) : _vm._e(),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }